import { staticEnv } from 'env';
import { ApiGConfig } from 'models';

export const config: ApiGConfig = {
  name: 'httpcalls',
  endpoint: staticEnv.IS_PRODUCTION ? 'https://caller.prod.api.nwave.io' : 'https://caller.dev.api.nwave.io'
};